export const PROPS = {
  label: 'Postcode',
  placeholder: 'Postcode',
};
